import React, { memo, useCallback, useState } from 'react';
import './Styles.css';
import { updatePostalCode } from './PostalFieldsFunctions';
import { useDebouncedEffect } from '../../../../../Helpers/CustomHooks';
import TextInput from '../../../../ids/InputElements/TextInput';
import ErrorMessage from '../../../../ErrorMessage';
import Messages from '../../../../../Localization/Messages';
import { formatMessage } from '../../../../../Localization/formatMessage';

const PostalFields = ({ getCommonFields, setAddressState, addressState }) => {
  const [postalCode, setPostalCode] = useState(addressState.address.postalCode ?? '');

  const searchPostalCode = useCallback(() => {
    if (postalCode !== addressState.address.postalCode) {
      updatePostalCode(addressState.address.country, setAddressState, addressState, postalCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postalCode]);

  useDebouncedEffect(searchPostalCode, 1000);

  return (
    <>
      <div className="addressSwitcher-postalField-row">
        <div className="addressSwitcher-postalField-postalCode">
          <TextInput
            label={formatMessage(Messages.addressInfo_postalCode)}
            {...getCommonFields('postalCode', true)}
            value={postalCode}
            onChange={e => {
              setPostalCode(e.target.value);
            }}
            error={null}
          />
        </div>
        <div className="addressSwitcher-postalField-city">
          <TextInput
            label={formatMessage(Messages.addressInfo_city)}
            placeholder={formatMessage(Messages.addressInfo_cityPlaceholder)}
            disabled={true}
            value={addressState.address.city}
          />
        </div>
      </div>

      <ErrorMessage message={addressState.errors.postalCode} />
    </>
  );
};

export default memo(PostalFields);
